export const getLoginNoticeStorageKey = (user) => {
  const notice = user?.loginNotice;
  if (!notice?.enabled || !String(notice.text || "").trim()) {
    return null;
  }

  const enterpriseId = notice.enterpriseId || user.enterprise_Id;
  const userId = user.user_id || user.id;
  if (!enterpriseId || !userId) {
    return null;
  }

  return `synaccess:loginNoticeAck:${enterpriseId}:${userId}:${notice.updatedAt || "unversioned"}`;
};

export const isLoginNoticeAcknowledged = (user, storage = window.localStorage) => {
  const key = getLoginNoticeStorageKey(user);
  return Boolean(key && storage.getItem(key) === "true");
};

export const acknowledgeLoginNotice = (user, storage = window.localStorage) => {
  const key = getLoginNoticeStorageKey(user);
  if (!key) {
    return null;
  }

  storage.setItem(key, "true");
  return key;
};
